import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';

const CarouselControl = styled.div`
    position: absolute;
    bottom: 0;
    z-index: 1;
    background-color: transparent;
    cursor: pointer;
    font-size: 0.9rem;
`;

export const PrevControl = styled(CarouselControl)`
    right: 40px;
    padding-right: 20px;
`;
export const NextControl = styled(CarouselControl)`
    right: 0;
`;

export const ControlTextIcon = styled.div`
    opacity: 0.5;
    display: flex;
    align-items: baseline;
    &:hover {
        opacity: 1;
    }
`;

const ControlArrow = styled.span`
    background: transparent no-repeat center center;
    background-size: 100% 100%;
    width: 10px;
    height: 10px;
`;
export const PrevArrow = styled(ControlArrow)`
    margin-right: 5px;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' stroke='%23000' stroke-width='.25px' fill='%23000' viewBox='0 0 8 8'%3E%3Cpath d='M4 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
`;
export const NextArrow = styled(ControlArrow)`
    margin-left: 7px;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' stroke='%23000' stroke-width='.25px' fill='%23000' viewBox='0 0 8 8'%3E%3Cpath d='M1.5 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
`;
